export default __webpack_public_path__ + "static/media/postman.36e6a273.png";